import request from '@/utils/request'

/**
 * 分页查询SKU
 */
export function getSkuPage(params) {
  return request({
    url: '/admin/sku/page',
    method: 'get',
    params
  })
}

/**
 * 获取SKU详情
 */
export function getSkuDetail(skuId) {
  return request({
    url: '/admin/sku/detail',
    method: 'get',
    params: { skuId }
  })
}

/**
 * 新增SKU
 */
export function createSku(data) {
  return request({
    url: '/admin/sku',
    method: 'post',
    data
  })
}

/**
 * 修改SKU
 */
export function updateSku(data) {
  return request({
    url: '/admin/sku',
    method: 'put',
    data
  })
}

/**
 * 删除SKU
 */
export function deleteSku(ids) {
  return request({
    url: '/admin/sku',
    method: 'delete',
    data: ids
  })
}

/**
 * 批量删除SKU
 */
export function batchDeleteSku(ids) {
  return request({
    url: '/admin/sku',
    method: 'delete',
    data: ids
  })
}

/**
 * 批量修改状态
 */
export function updateSkuStatus(ids, status) {
  return request({
    url: '/admin/sku/status',
    method: 'put',
    params: { status },
    data: ids
  })
}

/**
 * 生成SKU编码
 */
export function generateSkuId(ruleCode, specParams) {
  return request({
    url: '/admin/sku/generateId',
    method: 'post',
    params: { ruleCode },
    data: specParams
  })
}

/**
 * 分页查询库存
 */
export function getInventoryPage(params) {
  return request({
    url: '/admin/inventory/page',
    method: 'get',
    params
  })
}

/**
 * 入库
 */
export function inventoryInbound(data) {
  return request({
    url: '/admin/inventory/inbound',
    method: 'post',
    params: data
  })
}

/**
 * 出库
 */
export function inventoryOutbound(data) {
  return request({
    url: '/admin/inventory/outbound',
    method: 'post',
    params: data
  })
}

/**
 * 调拨
 */
export function inventoryTransfer(data) {
  return request({
    url: '/admin/inventory/transfer',
    method: 'post',
    params: data
  })
}

/**
 * 分页查询仓库
 */
export function getWarehousePage(params) {
  return request({
    url: '/admin/warehouse/page',
    method: 'get',
    params
  })
}

/**
 * 获取可用仓库列表
 */
export function getWarehouseList() {
  return request({
    url: '/admin/warehouse/list',
    method: 'get'
  })
}

export function getSkuProductPoints(skuId) {
  return request({
    url: `/admin/sku/${skuId}/points`,
    method: 'get'
  })
}

export function updateSkuProductPoints(skuId, productPoints) {
  return request({
    url: `/admin/sku/${skuId}/points`,
    method: 'put',
    data: { productPoints }
  })
}

export function batchUpdateSkuProductPoints(skuPointsMap) {
  return request({
    url: '/admin/sku/batch-points',
    method: 'put',
    data: skuPointsMap
  })
}
